import dayjs, { Dayjs } from 'dayjs';

export const getDisabledDate = (date: Dayjs) => date.isAfter() && !date.isSame(dayjs(), 'day');
export const getDisabledHours = () =>
  Array(24)
    .fill(null)
    .map((_, index) => index)
    .filter(h => h >= new Date().getHours() + 1);
